import Invoice from "../../../model/invoice/Invoice";
import InvoiceEvent from "../../../model/invoice/event/InvoiceEvent";
import Payment from "../../../model/payment/Payment";

export const INVOICE_FETCHED = "INVOICE_FETCHED";
export type INVOICE_FETCHED = { jobId: string, invoice: Invoice }

export const INVOICE_UPDATED = "INVOICE_UPDATED";
export type INVOICE_UPDATED = { jobId: string, invoice: Invoice }

/**
 * Invoice events fetched action.
 */
export const INVOICE_EVENTS_FETCHED = "INVOICE_EVENTS_FETCHED";
export type INVOICE_EVENTS_FETCHED = { invoiceId: string, events: Array<InvoiceEvent> }

/**
 * Invoice payments fetched action.
 */
export const INVOICE_PAYMENTS_FETCHED = "INVOICE_PAYMENTS_FETCHED";
export type INVOICE_PAYMENTS_FETCHED = { invoiceId: string, payments: Array<Payment> }
